import axios from "axios";

import Token from "../../utilities/jwt/Token.js";

export default class ProjectService extends Token {
  
  findAll() {
    return axios({
      method: "get",
      url: this.api_url + "project",
      withCredentials: true,
    }).then((res) => res.data);
  }

  create(permission) {
    return axios({
      method: "post",
      url: this.api_url + "project",
      withCredentials: true,
      data: permission,
    });
  }
  
  update(permission) {
    return axios({
      method: 'put',
      url: this.api_url + 'project/' + permission.id,
      withCredentials: true,
      data: permission,
    });
  }

  delete(id) {
    return axios({
      method: 'delete',
      url: this.api_url + 'project/' + id,
      withCredentials: true,
    });

  }
}
